import { getClient } from 'azure-devops-extension-api';
import { WorkItemTrackingRestClient, } from 'azure-devops-extension-api/WorkItemTracking';


export function getWorkItem(projectId: string) {
	const client = getClient(WorkItemTrackingRestClient);
	return client.getWorkItemTypes(projectId);
}

export async function getFields(projectId: string) {
	const client = getClient(WorkItemTrackingRestClient);
	return client.getFields(projectId);
}